import { atom } from 'jotai';

export const employerRestaurantLocationFilterAtom = atom('');
employerRestaurantLocationFilterAtom.debugLabel = 'employerRestaurantLocationFilterAtom';

export const employerRestaurantJpStatusFilterAtom = atom<string[]>([]);
employerRestaurantJpStatusFilterAtom.debugLabel = 'employerRestaurantJpStatusFilterAtom';

export const restaurantSortAtom = atom('desc:inserted_at');
restaurantSortAtom.debugLabel = 'restaurantSortAtom';

export const restaurantSearchQueryAtom = atom('');
restaurantSearchQueryAtom.debugLabel = 'restaurantSearchQueryAtom';

export const hasEmployerViewedRestaurantDetailsPageAtom = atom(false);
hasEmployerViewedRestaurantDetailsPageAtom.debugLabel = 'hasEmployerViewedRestaurantDetailsPage';

export const showContactRestWorldManagerModalAtom = atom(false);
showContactRestWorldManagerModalAtom.debugLabel = 'showContactRestWorldManagerModal';

export const isShowcaseVisibilityToggleModalOpenAtom = atom(false);
